import { HttpInterceptorFn } from '@angular/common/http';
import { resolveBrowserTimeZone } from '../../shared/utils/date.utils';

/**
 * Añade la zona horaria del usuario (id IANA) a toda petición saliente.
 *
 * El backend la necesita para acotar el rango de fechas: el front manda DÍAS
 * NATURALES (`dateFrom`/`dateTo` como `YYYY-MM-DD`), y un día natural solo
 * designa un tramo de la línea temporal cuando se sabe en qué zona lo eligió
 * quien lo pidió. Sin ella, "hoy" en Madrid se consultaba como el día UTC: se
 * perdían las dos primeras horas del día del usuario y se colaban las dos
 * primeras del día siguiente.
 *
 * Va en cabecera y no en el cuerpo por lo mismo que `Accept-Language` y
 * `x-company-id`: es contexto de la petición, así la reciben de una vez todos
 * los endpoints de informes y ningún DTO cambia.
 *
 * Se resuelve en cada petición, no una vez al cargar el módulo: un portátil que
 * cruza un huso o entra por VPN cambia de zona con la sesión ya abierta, y el
 * coste de preguntárselo a `Intl` es irrelevante al lado de la propia llamada.
 * Si no se puede determinar no se manda nada y el backend consulta en UTC,
 * exactamente como antes.
 */
export const timezoneInterceptor: HttpInterceptorFn = (req, next) => {
  const timeZone = resolveBrowserTimeZone();
  if (!timeZone) return next(req);

  return next(req.clone({ setHeaders: { 'X-Time-Zone': timeZone } }));
};
